// orderDetailData: {
// "isLegacyOrder": false,                               // 是否為舊站訂單
// "orderType": "PREORDER",                              // 訂單類型(MOTORCYCLE、PREORDER)
// "paymentAuthorizedStatus": "SUCCESS",                 // 付款狀態(SUCCESS/FAILED)
// "hasCreatedConsignment": true,  // ? 翻譯起來像是產生出貨單了沒                  
// "orderId": "p20653007",         // 會員帶入ordercode，非會員為guid
// "orderStatus": "已開發票",       // 訂單狀態
// "orderPromotions": [],          // 行銷活動(列在商品下方)orderPromotions[index].description
// "appliedBonusTotal": 0,         // 沒有用到   使用的紅利金金額" (不太確定可問佳玲看看)
// "motoAllowCancel": false,       // ? (可能是摩托車訂單是否可以退貨)
// "productPromotions": [          // 行銷活動(列在商品下方)
//   {
//     "description":""
//   }
// ],        
// "ordernetry": [
//     {
//         "hasPrintAllowanceButton": false,             // 判斷有無折讓單可列印
//         "totalPrice": "$5,700",                       // 小計
//         "discountPrice": "$0",                        // 折扣價
//         "PointOfServiceAddress": "",                  // 店取地址(不太確定可問佳玲看看)
//         "rtnRequestB2B": "N",                         // ?
//         "sharedBonusDiscount": 0,                     // 沒有用到
//         "displayReturnOrCancel": "",                      // 是否顯示退貨(checkbox)? RETURN_REFUND、REFUND (空代表已取消或退貨)
//         "returnType": "",                                 // (若有值代表可取消或退貨)
//         "preOrderExpectedShipDate": "",                   // 預計到貨日
//         "price": "$2,850",                                // 網購價
//         "shareVendor": "",                                // ?
//         "logisticInfo": [
//             {
//                 "carrier": "新竹貨運",                     // 物流公司
//                 "deliveryMode": "trplus-vendor-shipping", // 物流模式(影響物流狀況顯示判斷)(pickup,trplus-vendor-shipping,trplus-shipping)
//                 "trackingId": "124434325365",             // 物流單號
//                 "status": "出貨完成"                       // 物流狀態
//             }
//         ],
//         "returnOrderEntryStatusRecords": [                // 退貨狀態紀錄
//             {
//                 "statusChangeDate": 1637206833405,      // 狀態時間
//                 "status": "退款中"                       // 退貨狀態
//             },
//             {
//                 "statusChangeDate": "",
//                 "status": "退款完成"
//             }
//         ],
//         "refundRequestCode": "",                          // 沒有用到  退款退貨單號 (不太確定可問佳玲看看)
//         "quantity": 2,                                    // 商品數量
//         // 商品圖片
//         "productImg": "https://pcmuat.trplus.com.tw/96x96/sys-master/productImages/hcb/hc3/9076225343518/000000000016536251-gallery-01-20210903140135387.jpg",
//         "productCode": "016536251",    // 商品編號
//         // 商品名稱
//         "productName": "&#32654;&#22283; HOMEDICS &#23478;&#37291; &#38568;&#36523;&#32043;&#22806;&#32218;&#28357;&#33740;&#28040;&#27602;&#30418; SAN-PH100&#40657;&#20874;&#20874;&#20874;&#20874;&#27425;AAAAAAA",
//         "refundRequests": "",                             // 退款單號
//         "returnRequests": "",                             // 退貨單號
//         "needInstallationFlag": false,                    // 沒有用到  是否需要安裝
//         "promotionLabel": "",                             // 促銷文字
//         "entryNumber": "0",                               // ?
//         "PointOfServiceName": "",                         // 沒有用到  店取地址 (不太確定可問佳玲看看)
//         "preOrderDays": 3                                 // 預購天數
//         // 額外費用列在這邊
//         "installationFeeAmount": "$0",  // 安運費(判斷顯示是否安裝)
//         "volumeExceedFeeAmount": "$0",  // 超材計費
//         "weightExceedFeeAmount": "$0",  // 超種計費
//         "ascendingFeeAmount": "$0",     // 登高費
//     }
// ],
// "orderCode": "p20653007",              // 訂單編號
// // 關於錢的部分頁列在這邊
// // (只會出現在網址: ?activeTab=orderReturn)---------------------
// "returnTotal": 0,                      // 總退款費用 (不太確定可問佳玲看看)
// "hasCreateDeliveryRefund": false,      // 判斷是否顯示deliveryCost
// "deliveryCost": "$0",                  // 運費
// // (網址不包含 ?activeTab=orderReturn)--------------------------
// "subTotal": "$5,700",                  // 合計
// "orderDiscount": "$0",                 // 活動共折抵
// "installationFeeTotal": "$0",          // 安裝費總額
// "ascendingFeeTotal": "$0"              // 登高費總額
// "remoteLocationFee": "$0",             // 偏遠地區費
// "totalPrice": "$5,700",                // 消費總額
// "volumeExceedFeeTotal": "$0",          // 超材費總額 (畫面上與超重合併計費)
// "weightExceedFeeTotal": "$0",          // 超重費總額
// "trpayInfo": [],                       // 特力pay(列在金額下方) [{name, value}]

// // 繳費資訊列在這邊
// "pincodeType": "",                     // 全家或小7 (只有用超商繳費才會有值 , 否則為空值)
// "pincode": "",                         // 繳款代碼 (只有用超商繳費才會有值 , 否則為空值)
// "pincodeDeadline": "",                 // 繳款期限 (只有用超商繳費才會有值 , 否則為空值)

// // 退貨收件資訊列在這邊
// "receiverName": "喵喵",                // 收貨人姓名
// "deliveryAddress": "&#33274;&#21271;&#24066; &#21271;&#25237;&#21312; &#26032;&#28246;&#19977;&#36335;23&#34399;6&#27155;",
// // 收貨人地址：
// }

export const newOrderDetailData = (orderDetailData) => {

  // 例外判斷有沒有ordernetry
  if (orderDetailData.hasOwnProperty('ordernetry') && orderDetailData.ordernetry) {

    // 是否顯示折讓單欄位(th) --初始化
    orderDetailData.showAllowanceColumn = false;
    // 是否顯示退貨單號欄位(th) --初始化
    orderDetailData.showReturnOrderColumn = false;


    orderDetailData.ordernetry.forEach(item => {

      // 退單欄位顯示開關
      item.returnConfig = {
        // 退貨欄位是否顯示客服連結(舊系統訂單)
        isLegacyOrder: false,
        // 退貨欄位是否顯示退貨選項
        canReturn: false,
        // 退貨欄位是否顯示取消選項
        canRefund: false,
        // 退貨欄位顯示退貨紀錄彈出視窗開關
        showReturnRecords: false,
      }


      // 退貨地點(初始將訂單配送地傳入每個商品userAddressTxt)
      item.userAddressTxt = orderDetailData.deliveryAddress;
      // -----------------依照舊版js判斷-----------------------------
      // 如果是舊系統的訂單只要顯示客服連結
      // 如果商品總額不為0、付款狀態成功、已產生出貨單、顯示退貨為REFUND或RETURN_REFUND
      if (orderDetailData.isLegacyOrder === true) {
        item.returnConfig.isLegacyOrder = true;
      } else if (
        item.totalPrice !== '0.0' &&
        orderDetailData.paymentAuthorizedStatus != null &&
        orderDetailData.paymentAuthorizedStatus != 'FAILED' &&
        orderDetailData.hasCreatedConsignment == true &&
        item.displayReturnOrCancel !== null &&
        (item.displayReturnOrCancel == 'REFUND' || item.displayReturnOrCancel == 'RETURN_REFUND')
      ) {
        // 如果有店取地址
        if (item.PointOfServiceAddress != "") {
          // 舊版以pickupNumber===1來當作是不是店取的判斷
          item.pickupNumber = 1;
          item.userAddressTxt = '請將商品帶回原取貨門市店，門市地址:' + item.PointOfServiceAddress;
        }

        // 如果訂單類別不是機車或是機車(但可以退貨)
        if (orderDetailData.orderType != 'MOTORCYCLE' ||
          (orderDetailData.orderType == 'MOTORCYCLE' && orderDetailData.motoAllowCancel)) {
          // 如果是可以退貨，退單欄位顯示退貨
          if (item.displayReturnOrCancel == 'RETURN_REFUND') {
            item.returnConfig.canReturn = true;
          }
          // 如果是可以退款，退單欄位顯示取消
          if (item.displayReturnOrCancel == 'REFUND') {
            item.returnConfig.canRefund = true;
          }
        }
      }

      // 退貨欄位預設顯示第一筆退貨紀錄的狀態
      let returnRecordStatus = item.returnOrderEntryStatusRecords[0].status;
      // 如果有第一筆退貨狀態且訂單不是舊系統
      if (returnRecordStatus != "" && !orderDetailData.isLegacyOrder) {
        // 退單欄位顯示貨紀錄的狀態
        item.returnConfig.showReturnRecords = true;
        item.returnOrderEntryStatusRecords.forEach((returnStatusRecord) => {
          // 取得最後一筆有紀錄時間的資料，將退貨欄位顯示的文字改成該筆資料的狀態
          // timeString用來記錄格式化後的日期
          if (returnStatusRecord.statusChangeDate) {
            returnStatusRecord.timeString = getDateTime(returnStatusRecord.statusChangeDate);
            returnRecordStatus = returnStatusRecord.status;
          } else {
            returnStatusRecord.timeString = '';
          }
        })
      }
      // 退貨欄位顯示的退貨狀態
      item.returnText = returnRecordStatus;

      // 如果某個紀錄有顯示折讓單則th也要顯示折讓單
      if (item.hasPrintAllowanceButton) {
        orderDetailData.showAllowanceColumn = true;
      }

      // 如果某個紀錄有退貨單則th也要顯示退貨單
      if (item.returnRequests !== '') {
        orderDetailData.showReturnOrderColumn = true;
      }
    })
  }

  console.log(orderDetailData);

  return orderDetailData
};

// 將紀錄時間戳記轉換為字串ex: 1637206833405 -> 2021/11/18 11:40:33
function getDateTime(statusChangeDate) {
  const timeString_o = new Date(statusChangeDate);
  let timeString = timeString_o.toString();

  const month = new Array(12);
  month[0] = "01";
  month[1] = "02";
  month[2] = "03";
  month[3] = "04";
  month[4] = "05";
  month[5] = "06";
  month[6] = "07";
  month[7] = "08";
  month[8] = "09";
  month[9] = "10";
  month[10] = "11";
  month[11] = "12";
  var monthValue = timeString_o.getMonth(timeString_o);

  timeString = timeString_o.getFullYear(timeString_o) + '/' + month[monthValue] + '/' + timeString_o.getDate(timeString_o) + '  ' + timeString.slice(16, -18);
  return timeString
}

// 這裡的orderDetailData是從jsp(orderDetail))來的
// export const finalOrderDetailData = newOrderDetailData(orderDetailData);




// 新版
export const returnOrderDetailData = (orderDetailData) => {
  // 例外判斷有沒有ordernetry
  if (orderDetailData.hasOwnProperty('ordernetry') && orderDetailData.ordernetry) {
    const {
      isLegacyOrder,
      // appliedBonusTotal,         // 看不出來哪裡有使用
      ascendingFeeTotal,
      deliveryAddress,
      deliveryCost,
      hasCreateDeliveryRefund,
      hasCreatedConsignment,
      installationFeeTotal,
      installDiscountTotal,
      motoAllowCancel,
      orderCode,
      orderDiscount,
      orderId,
      orderPromotions,
      orderStatus,
      orderType,
      ordernetry,
      paymentAuthorizedStatus,
      pincode,
      pincodeDeadline,
      pincodeType,
      productPromotions,
      receiverName,
      remoteLocationFee,
      returnTotal,
      showAllowanceColumn,
      showReturnOrderColumn,
      subTotal,
      totalPrice,
      trpayInfo,
      volumeExceedFeeTotal,
      weightExceedFeeTotal,
      baseInstallTotal,
      ipsDeliveryCost,
      ipsAscending,
      ipsOverWeight,
      ipsRemotionLocation,
    } = orderDetailData;

    let returnDetailData = {
      // return: {
      //   total: returnTotal,
      // },
      delivery: {
        // 登高費
        ascendingFee: ascendingFeeTotal,
        address: deliveryAddress,
        // 退貨運費
        cost: deliveryCost,
        // 安裝費
        installationFee: installationFeeTotal,
        //折基本安裝費
        installDiscountTotal: installDiscountTotal,
        // 偏遠費用
        longDistanceShipping: remoteLocationFee,
        // 基本出工費
        baseInstallFee: baseInstallTotal,
        // 專人約配商品運費
        ipsDeliveryCost: ipsDeliveryCost,
        // 專人約配商品登高費
        ipsAscending: ipsAscending,
        // 專人約配商品超重超才費加成
        ipsOverWeight: ipsOverWeight,
        // 專人約配偏遠地區運送費加成
        ipsRemotionLocation: ipsRemotionLocation,
      },
      config: {
        // 是否是舊系統訂單
        isLegacyOrder: isLegacyOrder,
        // 是否有退貨運費 deliveryCost
        isShowDeliveryRefund: hasCreateDeliveryRefund,
        // 是否已經產生出貨單 / 選項
        isShowConsignment: hasCreatedConsignment,
        // 摩托車是否可以取消 需要跟 orderType != 'MOTORCYCLE' 一起判斷
        isAllowCancelMotorcycle: motoAllowCancel && orderType === 'MOTORCYCLE',
        // 是否顯示折讓單
        isShowDiscountColumn: false,
        // 是否顯示退貨單號
        isShowReturnOrderColumn: false,
      },
      order: {
        // 理論上是紅利金折抵
        // appliedBonus: appliedBonusTotal,
        code: orderCode,
        discount: orderDiscount,
        id: orderId,
        
        status: orderStatus,
        type: orderType,
        trPayInfo: trpayInfo,
        subTotal: subTotal,
        totalPrice: totalPrice,
        returnTotal: returnTotal
      },

      promotions: {
        product: productPromotions,
        order: orderPromotions,
        total: getTotalPromotions(productPromotions, orderPromotions),
      },

      payment: {
        authenticStatus: paymentAuthorizedStatus,
      },

      pincode: {
        code: pincode,
        deadline: pincodeDeadline,
        type: pincodeType,
      },

      member: {
        receiver: receiverName,
      },

      exceed: {
        volume: volumeExceedFeeTotal,
        weight: weightExceedFeeTotal,
      }
    };

    let listArray = [];
    ordernetry.map((orderEntryItem) => {
      const {
        PointOfServiceAddress,
        PointOfServiceName,
        ascendingFeeAmount,
        discountPrice,
        displayReturnOrCancel,
        entryNumber,
        hasPrintAllowanceButton,
        installationFeeAmount,
        logisticInfo,
        needInstallationFlag,
        preOrderDays,
        preOrderExpectedShipDate,
        price,
        productCode,
        productImg,
        productName,
        promotionLabel,
        quantity,
        refundRequestCode,
        refundRequests,
        returnConfig,
        returnOrderEntryStatusRecords,
        returnRequests,       // 退貨單號
        returnText,
        returnType,
        rtnRequestB2B,        // 約配商品判斷欄位(目前還沒有資料)
        shareVendor,
        // sharedBonusDiscount,  // 好像沒用
        totalPrice,
        userAddressTxt,
        volumeExceedFeeAmount,
        weightExceedFeeAmount,
        bundleProductName, // 組合商品母商品品名
        remark,           // 商品備註
      } = orderEntryItem;

      let listItem = {
        pointOfService: {
          address: PointOfServiceAddress,
          name: PointOfServiceName
        },
        product: {
          entryNumber: entryNumber,
          qty: quantity,
          // 是否需要安裝
          isInstallation: needInstallationFlag,
          preOrderDays: preOrderDays,
          code: productCode,
          image: productImg,
          name: productName,
          label: promotionLabel,
          bundleProductName: bundleProductName,
        },
        // 退款
        refund: {
          // 退款請求code
          requestCode: refundRequestCode,
          request: refundRequests,
        },
        price: {
          discount: discountPrice,
          price: price,
          total: totalPrice,
        },
        return: {
          orderEntryStatusRecords: returnOrderEntryStatusRecords,
          request: returnRequests,
          rtnRequestB2B: rtnRequestB2B === 'Y',
          text: '',
          type: returnType,
        },
        delivery: {
          // 登高費
          ascendingFee: ascendingFeeAmount,
          // 安裝費
          installation: installationFeeAmount,
          // 預期到貨日
          preOrderExpectedShipDate: preOrderExpectedShipDate,
          // 專人約配商品運費
          ipsDeliveryCost: ipsDeliveryCost,
          // 專人約配商品登高費
          ipsAscending: ipsAscending,
          // 專人約配商品超重超才費加成
          ipsOverWeight: ipsOverWeight,
          // 專人約配偏遠地區運送費加成
          ipsRemotionLocation: ipsRemotionLocation,
          
          list: logisticInfo
        },
        member: {
          address: userAddressTxt
        },
        config: {
          // displayReturnOrCancel
          isShowReturnCheckBox: false,
          // 是否有無折讓單列印
          isShowPrintDiscountColumn: hasPrintAllowanceButton,
          isShowReturnRecords: false,
          isLegacyOrder: isLegacyOrder,
        },
        exceed: {
          volume: volumeExceedFeeAmount,
          weight: weightExceedFeeAmount,
        },

        shareVendor: shareVendor,
        remark: remark,
      };

      if (orderEntryItem.hasPrintAllowanceButton) {
        returnDetailData.config.isShowDiscountColumn = true;
      }

      if (orderEntryItem.returnRequests !== '') {
        returnDetailData.config.isShowReturnOrderColumn = true;
      }

      // 判斷是否顯示退貨、取消checkbox
      if (!isLegacyOrder) {
        if (
          totalPrice !== '0.0' &&
          paymentAuthorizedStatus != null &&
          paymentAuthorizedStatus != 'FAILED' &&
          hasCreatedConsignment == true &&
          (displayReturnOrCancel == 'REFUND' || displayReturnOrCancel == 'RETURN_REFUND')
        ) {

          // 如果訂單類別不是機車或是機車(但可以退貨)
          if (orderType != 'MOTORCYCLE' ||
            (orderType == 'MOTORCYCLE' && motoAllowCancel)) {
            // 如果是可以退貨，退單欄位顯示退貨
            listItem.config.isShowReturnCheckBox = true;
            if (displayReturnOrCancel == 'REFUND') {
              listItem.return.text = '取消'
            }
            if (displayReturnOrCancel == 'RETURN_REFUND') {
              listItem.return.text = '退貨'
            }
          }
        }
      }

      // 退貨欄位預設顯示第一筆退貨紀錄的狀態
      let returnRecordStatus = listItem.return.orderEntryStatusRecords[0].status;
      // 如果有第一筆退貨狀態且訂單不是舊系統
      if (returnRecordStatus != "" && !isLegacyOrder) {
        // 退單欄位顯示貨紀錄的狀態
        listItem.config.isShowReturnRecords = true;
        listItem.config.isShowReturnCheckBox = false;

        listItem.return.orderEntryStatusRecords.forEach((returnStatusRecord) => {
          // 取得最後一筆有紀錄時間的資料，將退貨欄位顯示的文字改成該筆資料的狀態
          // timeString用來記錄格式化後的日期
          if (returnStatusRecord.statusChangeDate) {
            returnStatusRecord.timeString = getDateTime(returnStatusRecord.statusChangeDate);
            returnRecordStatus = returnStatusRecord.status;
          } else {
            returnStatusRecord.timeString = '';
          }
        })
      }
      if(listItem.config.isShowReturnRecords) {
        listItem.return.text = returnRecordStatus
      }

      // console.log(listItem);
      listArray.push(listItem);
    })
    returnDetailData.list = listArray;
    console.log(returnDetailData);

    return returnDetailData;
  }

  // console.log(orderDetailData);

  return orderDetailData
};

function getTotalPromotions(productPromotions, orderPromotions) {
  let totalPromotion = [];
  if(productPromotions && productPromotions.length) {
    totalPromotion = [...productPromotions];
  }
  if(orderPromotions && orderPromotions.length) {
    totalPromotion = [...totalPromotion, ...orderPromotions];
  }
  return totalPromotion;
}
